import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Inject, Injectable, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modalClosedSource = new Subject<void>();

  modalClosed$ = this.modalClosedSource.asObservable();

  closeModal(): void {
    this.modalClosedSource.next();
  }
}

@Component({
  selector: 'app-contact-modal',
  templateUrl: './pces-lists-modal.component.html',
  styleUrls: ['./pces-lists-modal.component.scss']
})
export class PCESModalComponent  implements OnInit {

  modalTitle: string;
  modalMessage: any;
  
  deleteClientInfoForm!: FormGroup;
  deleteEmailForm!: FormGroup;
  createEmailForm!: FormGroup;
  deletePendingEmailForm!: FormGroup;
  deletePendingTransactionForm!: FormGroup;
  sendEmailForm!: FormGroup;
  sendALLEmailForm!: FormGroup;
  deleteAllTransactionForm!: FormGroup;  
  deleteAllEmailForm!: FormGroup;  
  uploadPaymentReportFileForm!: FormGroup;
  uploadTransactionFileForm!: FormGroup;
  createCDNTransactionFileForm!: FormGroup;
  createUSTransactionFileForm!: FormGroup;
  createUS_CDNTransactionFileForm!: FormGroup;

  constructor(
    public dialogRef: MatDialogRef<PCESModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private http: HttpClient,
    private toastr: ToastrService,
    private modalService: ModalService,
    private router: Router
  ) {
    this.modalTitle = data.data.modalTitle;
    this.modalMessage = data.data.modalMessage;

    console.log('Modal Title:', this.modalTitle);
    console.log('Modal Message:', this.modalMessage);

    this.deleteClientInfoForm = this.fb.group({
      client_name: this.modalMessage.client_name,
      client_uuid: this.modalMessage.uuid,
    });    

    this.deleteEmailForm = this.fb.group({
      client_name: this.modalMessage.client_name,
      email_uuid: this.modalMessage.uuid,
    });   

    this.createEmailForm = this.fb.group({
      clientname: [''],
      email: [''],
    });   

    this.deletePendingEmailForm = this.fb.group({
      client_name: this.modalMessage.client_name,
      pces_outgoing_email_uuid: this.modalMessage.uuid,
    });  

    this.deletePendingTransactionForm = this.fb.group({
      client_name: this.modalMessage.client_name,
      pces_transaction_uuid: this.modalMessage.uuid,
    });  

    this.sendEmailForm = this.fb.group({
      client_name: this.modalMessage.client_name,
      pces_outgoing_email_uuid: this.modalMessage.uuid,
    });  

    this.sendALLEmailForm = this.fb.group({

    });  

    this.deleteAllTransactionForm = this.fb.group({
    });  

    this.deleteAllEmailForm = this.fb.group({
    });  

    this.uploadPaymentReportFileForm = this.fb.group({
      start_no: [''],
      limit: [''],
    });

    this.uploadTransactionFileForm = this.fb.group({
    });

    this.createCDNTransactionFileForm = this.fb.group({
      days: [''],      
    });

    this.createUSTransactionFileForm = this.fb.group({
      days: [''],      
    });

    this.createUS_CDNTransactionFileForm = this.fb.group({
      days: [''],      
    });    

  }

  ngOnInit(): void {
    this.loadData();
  }

  loadData() {

  }  

  closeModal() {
    this.dialogRef.close();
  }

  showSpinner = false;

  deleteClientInfo() {
    const delete_client_info_url = `/api/pces_lists/pces_client_details.php?command=CLIENT_INFO_DELETE`;
  
    var postData = this.deleteClientInfoForm.value;
  
    console.log('Post Data:', postData);
  
    return this.http.post<any>(delete_client_info_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You Deleted a Client Information successfully.'); 
        this.closeModal();
        location.reload();
      })
  }

  deleteEmail() {
    const delete_email_url = `/api/pces_lists/pces_client_details.php?command=EMAIL_DELETE`;
  
    var postData = this.deleteEmailForm.value;
  
    console.log('Post Data:', postData);
  
    return this.http.post<any>(delete_email_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You Deleted an Email successfully.'); 
        this.closeModal();
        location.reload();
      })
  }

  createEmail() {
    const create_email_url = `/api/pces_lists/pces_client_details.php?command=EMAIL_CREATE`;
  
    var postData = this.createEmailForm.value;
  
    console.log('Post Data:', postData);
  
    return this.http.post<any>(create_email_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You Created an Email successfully.'); 
        this.closeModal();
        location.reload();
      })
  }

  deletePendingEmail() {
    const delete_email_url = `/api/pces_lists/pces_client_details.php?command=EMAIL_PENDING_DELETE`;
  
    var postData = this.deletePendingEmailForm.value;
  
    console.log('Post Data:', postData);
  
    return this.http.post<any>(delete_email_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You Deleted an Email successfully.'); 
        this.closeModal();
        location.reload();
      })
  }

  deleteAllPendingEmail() {
    const send_email_url = `/api/pces_lists/pces_client_details.php?command=CLIENT_EMAIL_PENDING_DELETE_ALL`;
  
    var postData = this.deleteAllEmailForm.value;

    console.log('Post Data:', postData);
    this.showSpinner = true;

    return this.http.post<any>(send_email_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.showSpinner = false;
        this.toastr.success('You Delete All the Pending Emails successfully.'); 
        this.closeModal();
        location.reload();
      })
  }
    
  deletePendingTransaction() {
    const delete_transaction_url = `/api/pces_lists/pces_client_details.php?command=CLIENT_TRANSACTION_PENDING_DELETE`;
  
    var postData = this.deletePendingTransactionForm.value;
  
    console.log('Post Data:', postData);
  
    return this.http.post<any>(delete_transaction_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You Deleted an Transaction successfully.'); 
        this.closeModal();
        location.reload();
      })
  }
  
  deleteAllPendingTransaction() {
    const send_email_url = `/api/pces_lists/pces_client_details.php?command=CLIENT_TRANSACTION_PENDING_DELETE_ALL`;
  
    var postData = this.deleteAllTransactionForm.value;

    console.log('Post Data:', postData);
    this.showSpinner = true;

    return this.http.post<any>(send_email_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.showSpinner = false;
        this.toastr.success('You Delete All the Pending Transaction successfully.'); 
        this.closeModal();
        location.reload();
      })
  }
    

  sendPendingEmail() {
    const send_email_url = `/api/pces_lists/pces_client_details.php?command=EMAIL_SEND`;
  
    var postData = this.sendEmailForm.value;
  
    console.log('Post Data:', postData);
  
    return this.http.post<any>(send_email_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.toastr.success('You Sent an Email successfully.'); 
        this.closeModal();
        //window.location.replace("https://newams2.ulaap.com/pces_email_pending_lists");
      })
  }
  
  sendALLPendingEmail() {
    const send_email_url = `/api/pces_lists/pces_client_details.php?command=EMAIL_SEND_ALL`;
  
    var postData = this.sendALLEmailForm.value;

    console.log('Post Data:', postData);
    this.showSpinner = true;

    return this.http.post<any>(send_email_url, postData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.showSpinner = false;
        this.toastr.success('You Sent an Email successfully.'); 
        this.closeModal();
        location.reload();
      })
  }
  
  @ViewChild('fileInput') fileInput!: ElementRef;

  selectFile() {
    this.fileInput.nativeElement.click();
  }

  formData: any = new FormData();;

  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    // const formData = new FormData();
    this.formData.append('file', file, file.name);
    console.log('original upload form', this.formData);
  }

 
  submitPaymentReportFile() {
    const upload_url = `/api/pces_lists/upload_payment_report.php`;
    const form = this.uploadPaymentReportFileForm.value;

    Object.keys(form).forEach((key) => {
      if (key !== 'fileInput') {
        this.formData.append(key, form[key]);
      }
    });
    
    console.log('Post Data:', this.formData);
    this.showSpinner = true;

    return this.http.post<any>(upload_url, this.formData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.showSpinner = false;
        this.toastr.success('You Uploaded a Payment File successfully.'); 
        this.closeModal();
        location.reload();
      })
  }

   
  submitTransactionFile() {
    const upload_url = `/api/pces_lists/upload_transactions_report.php`;
    const form = this.uploadTransactionFileForm.value;

    Object.keys(form).forEach((key) => {
      if (key !== 'fileInput') {
        this.formData.append(key, form[key]);
      }
    });
    
    console.log('Post Data:', this.formData);
    this.showSpinner = true;

    return this.http.post<any>(upload_url, this.formData)
      .subscribe(response => {
        console.log('Post Response: ', response);
        this.showSpinner = false;
        this.toastr.success('You Uploaded a Transaction File successfully.'); 
        this.closeModal();
        location.reload();
      })
  }
   
  submitCreateCDNTransactionFile() {
    const accessToken = localStorage.getItem('access_token');
    const form = this.createCDNTransactionFileForm.value;
    const days = form['days'];
    const upload_url = `/api/pces_lists/create_CDN_transaction_file.php?days=${days}&mode=PRODUCTION&token=${accessToken}`;

    console.log('Post Data:', form);
    this.showSpinner = true;
    window.open(upload_url, "_blank")    
    this.closeModal();
  }

  submitCreateUSTransactionFile() {
      const accessToken = localStorage.getItem('access_token');
      const form = this.createCDNTransactionFileForm.value;
      const days = form['days'];
      const upload_url = `/api/pces_lists/create_US_transaction_file.php?days=${days}&mode=PRODUCTION&token=${accessToken}`;
  
      console.log('Post Data:', form);
      this.showSpinner = true;
      window.open(upload_url, "_blank")    
      this.closeModal();
    }

    submitCreateUS_CDNTransactionFile() {
      const accessToken = localStorage.getItem('access_token');
      const form = this.createCDNTransactionFileForm.value;
      const days = form['days'];
      const upload_url = `/api/pces_lists/create_US_CDN_transaction_file.php?days=${days}&mode=PRODUCTION&token=${accessToken}`;
  
      console.log('Post Data:', form);
      this.showSpinner = true;
      window.open(upload_url, "_blank")    
      this.closeModal();
    }

}

